interface OrderStatusBadgeProps {
  readonly status: string;
}

const STATUS_CONFIG: Record<string, { bg: string; text: string; label: string }> = {
  // New statuses
  awaiting_payment: { bg: 'var(--status-awaiting-bg)', text: 'var(--status-awaiting-text)', label: 'Awaiting Payment' },
  paid: { bg: 'var(--status-paid-bg)', text: 'var(--status-paid-text)', label: 'Paid' },
  queued: { bg: 'var(--status-printing-bg)', text: 'var(--status-printing-text)', label: 'Queued' },
  printing: { bg: 'var(--status-printing-bg)', text: 'var(--status-printing-text)', label: 'Printing' },
  post_processing: { bg: 'var(--status-post-processing-bg)', text: 'var(--status-post-processing-text)', label: 'Post-Processing' },
  packed: { bg: 'var(--status-packed-bg)', text: 'var(--status-packed-text)', label: 'Packed' },
  shipped: { bg: 'var(--status-shipped-bg)', text: 'var(--status-shipped-text)', label: 'Shipped' },
  delivered: { bg: 'var(--bg-success-subtle)', text: 'var(--color-success-600)', label: 'Delivered' },
  cancelled: { bg: 'var(--status-cancelled-bg)', text: 'var(--status-cancelled-text)', label: 'Cancelled' },
  refunded: { bg: 'var(--status-refunded-bg)', text: 'var(--status-refunded-text)', label: 'Refunded' },
  failed: { bg: 'var(--status-cancelled-bg)', text: 'var(--status-cancelled-text)', label: 'Failed' },
  // Legacy statuses
  received: { bg: 'var(--status-awaiting-bg)', text: 'var(--status-awaiting-text)', label: 'Received' },
  confirmed: { bg: 'var(--status-printing-bg)', text: 'var(--status-printing-text)', label: 'Confirmed' },
  rejected: { bg: 'var(--status-rejected-bg)', text: 'var(--status-rejected-text)', label: 'Rejected' },
};

const DEFAULT_CONFIG = { bg: 'var(--bg-surface-sunken)', text: 'var(--text-tertiary)', label: 'Unknown' };

export const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
  const config = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;

  return (
    <span
      style={{
        display: 'inline-block',
        borderRadius: 'var(--radius-full)',
        padding: 'var(--space-1) var(--space-3)',
        fontSize: 'var(--text-xs)',
        fontWeight: 'var(--font-weight-medium)',
        backgroundColor: config.bg,
        color: config.text,
      }}
    >
      {config.label}
    </span>
  );
};
